import React from 'react';

import { IServerOrder } from '@rbi-ctg/menu';
import { VisuallyHidden } from 'components/ucl/visually-hidden';
import useOrderNumber from 'hooks/use-order-number';
import { t } from 'state/intl/translations';
import { fullBrandName } from 'utils/environment';

import { MapCard } from './components/map-card';
import { OrderConfirmationHeader } from './components/order-confirmation-header';
import { ServiceModeHeading } from './components/service-mode-heading';
import { Container, Section } from './styled';

function ConfirmPickup({ serverOrder }: { serverOrder: IServerOrder }) {
  const orderNumber = useOrderNumber(serverOrder);

  return (
    <Container>
      <Section>
        <OrderConfirmationHeader serverOrder={serverOrder} />
      </Section>

      <Section>
        <ServiceModeHeading serviceMode={serverOrder.cart.serviceMode} />
        <MapCard
          storeAddress={serverOrder.cart.storeAddress}
          storeDetails={serverOrder.cart.storeDetails}
        />
      </Section>

      <VisuallyHidden
        role="alert"
        accessibilityLabel={t('pickUpOrderSuccessfulAlert', {
          orderNumber,
          brand: fullBrandName(),
          address: `${serverOrder.cart.storeAddress.addressLine1} ${serverOrder.cart.storeAddress.addressLine2}`,
        })}
      />
    </Container>
  );
}

export default React.memo(ConfirmPickup);
